"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VERIFY_CODE_INPUT_PLACEHOLDER = exports.VERIFY_CODE_INPUT_LABEL = exports.VERIFY_CODE_BUTTON_TEXT = exports.EMAIL_INPUT_PLACEHOLDER = exports.EMAIL_INPUT_LABEL = exports.CONFIRM_BUTTON_TEXT = void 0; // Email Form Component

var EMAIL_INPUT_LABEL = "Email";
exports.EMAIL_INPUT_LABEL = EMAIL_INPUT_LABEL;
var EMAIL_INPUT_PLACEHOLDER = "Enter Email Here";
exports.EMAIL_INPUT_PLACEHOLDER = EMAIL_INPUT_PLACEHOLDER;
var CONFIRM_BUTTON_TEXT = "Confirm"; // Verify Code Form Component

exports.CONFIRM_BUTTON_TEXT = CONFIRM_BUTTON_TEXT;
var VERIFY_CODE_INPUT_LABEL = "Code";
exports.VERIFY_CODE_INPUT_LABEL = VERIFY_CODE_INPUT_LABEL;
var VERIFY_CODE_INPUT_PLACEHOLDER = "PIN sent to email address";
exports.VERIFY_CODE_INPUT_PLACEHOLDER = VERIFY_CODE_INPUT_PLACEHOLDER;
var VERIFY_CODE_BUTTON_TEXT = "Confirm Code";
exports.VERIFY_CODE_BUTTON_TEXT = VERIFY_CODE_BUTTON_TEXT;
var _default = {
  EMAIL_INPUT_LABEL: EMAIL_INPUT_LABEL,
  EMAIL_INPUT_PLACEHOLDER: EMAIL_INPUT_PLACEHOLDER,
  CONFIRM_BUTTON_TEXT: CONFIRM_BUTTON_TEXT,
  VERIFY_CODE_INPUT_LABEL: VERIFY_CODE_INPUT_LABEL,
  VERIFY_CODE_INPUT_PLACEHOLDER: VERIFY_CODE_INPUT_PLACEHOLDER,
  VERIFY_CODE_BUTTON_TEXT: VERIFY_CODE_BUTTON_TEXT
};
exports["default"] = _default;